export default class OrderSigner {

  id!: number;
  orderId!: number;
  uuid!: string;
  type!: number;
  firstName!: string;
  lastName!: string;
  fullName!: string;
  email!: string;
  phone!: string;
  address!: string;
  address2!: string | null;
  city!: string;
  state!: string;
  zip!: string;
  position!: number;
  link!: string;
  latitude!: number;
  longitude!: number;
  activityStatus!: number;
  lastActiveTs!: number;
  ssn!: string;
  eSignConsentTs!: number;
  hasInsurance!: boolean | null;
  eSignConsentVersion!: string | null;
  isPaperCopyRequired!: boolean | null;
  createdTs!: number;
  updatedTs!: number;

  static TYPE_CUSTOMER = 1;
  static TYPE_DEALER = 2;

  static ACTIVITY_STATUS_OFFLINE = 0;
  static ACTIVITY_STATUS_IDLE = 1;
  static ACTIVITY_STATUS_ACTIVE = 2;

  static POSITION_MAIN_SIGNER = 1;
  static POSITION_CO_SIGNER = 2;

  static getActivityStatusMap() {
    return {
      [this.ACTIVITY_STATUS_OFFLINE]: 'Offline',
      [this.ACTIVITY_STATUS_IDLE]: 'Idle',
      [this.ACTIVITY_STATUS_ACTIVE]: 'Active',
    };
  }

  static getActivityStatusName(id: number) {
    return this.getActivityStatusMap()[id];
  }
}